module.exports = __webpack_public_path__ + "static/media/icon_0.7f038c8e.svg";